import React from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Upload,
  Button,
  Input,
} from "antd";

import {
  PlusCircleFilled,
  DeleteOutlined,
  UploadOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

const ImageSection = ({
  selectedAssets = [],
  addFile,
  removeFile,
  setSelectedAssets,
  handleAddAsset,
  setMainImage,
}) => {
  const [newAssetName, setNewAssetName] = React.useState("");

  const effectiveAssets = selectedAssets;


  


  const handleAssetNameChange = (assetIndex, value) => {
    setSelectedAssets((prev) => {
      const updated = [...prev];
      updated[assetIndex].name = value;
      return updated;
    });
  };

  const handleSpriteNameChange = (assetIndex, spriteIndex, value) => {
    setSelectedAssets((prev) => {
      const updated = [...prev];
      updated[assetIndex].data[spriteIndex].name = value;
      return updated;
    });
  };

  return (
    <Card className="editorContainer" bordered>
      <Title level={4}>Illusmaker - Bildressourcen</Title>

      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Name der Bildressource"
          value={newAssetName}
          onChange={(e) => setNewAssetName(e.target.value)}
          style={{ marginBottom: 12 }}
        />

        <Button
          type="primary"
          icon={<PlusCircleFilled />}
          disabled={!newAssetName.trim()}
          onClick={() => {
            const name = newAssetName.trim();

            if (!name) return;

            handleAddAsset(
              0,
              name,
              "/assets/images/resource_ico.png"
            );

            setNewAssetName("");
          }}
          style={{
            marginBottom: 16,
            height: 40,
            width: 300,
          }}
        >
          Neue Bildressource
        </Button>
      </div>

      {effectiveAssets.map((asset, assetIndex) =>
        asset.type === 0 ? (
          <Card
            key={`asset-${assetIndex}`}
            bordered
            style={{ marginBottom: 16 }}
          >
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Input
                  value={asset.name}
                  placeholder="Ressourcenname"
                  onChange={(e) =>
                    handleAssetNameChange(
                      assetIndex,
                      e.target.value
                    )
                  }
                  style={{ marginBottom: 16 }}
                />



<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 16,
    flexWrap: "wrap",
  }}
>
  {asset.mainImageUrl && (
    <img
      src={asset.mainImageUrl}
      alt={`${asset.name} – Hauptbild`}
      style={{
        width: 120,
        height: 100,
        objectFit: "contain",
        border: "1px solid #ddd",
        borderRadius: 8,
        padding: 8,
      }}
    />
  )}

  <Upload
    accept="image/*"
    maxCount={1}
    showUploadList={false}
    beforeUpload={(file) => {
      setMainImage(file, assetIndex);
      return false;
    }}
  >
    <Button icon={<UploadOutlined />}>
      Hauptbild hochladen
    </Button>
  </Upload>
</div>




                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 12,
                  }}
                >
                  {asset.data?.map((sprite, spriteIndex) => (
                    <div
                      key={spriteIndex}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: 8,
                        padding: 10,
                        width: 180,
                      }}
                    >
                      <img
                        src={sprite.url}
                        alt={sprite.name}
                        style={{
                          width: "100%",
                          height: 100,
                          objectFit: "contain",
                          marginBottom: 8,
                        }}
                      />

                      <Input
                        value={sprite.name}
                        placeholder="Bildname"
                        onChange={(e) =>
                          handleSpriteNameChange(
                            assetIndex,
                            spriteIndex,
                            e.target.value
                          )
                        }
                      />

                      <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() =>
                          removeFile(assetIndex, spriteIndex)
                        }
                        style={{ marginTop: 8 }}
                      />
                    </div>
                  ))}
                </div>

                <Upload
                  accept="image/*"
                  multiple
                  showUploadList={false}
                  beforeUpload={(file) => {
                    addFile(file, assetIndex);
                    return false;
                  }}
                >
                  <Button
                    icon={<UploadOutlined />}
                    style={{ marginTop: 16 }}
                  >
                    Bilder hinzufügen
                  </Button>
                </Upload>
              </Col>
            </Row>
          </Card>
        ) : null
      )}
    </Card>
  );
};

export default ImageSection;